import React, { useState } from "react";
import BaseCard from "../../../components/ui/BaseCard";
import useAuth from "../../../hooks/useAuth";
import DescriptionForm from "../../WorkOrder/Forms/DescriptionForm";
import EditServiceDescriptionModal from "../components/EditServiceDescriptionModal";
import { UserType } from "../../../utils/enum";

const ServiceDescription = ({
  description,
  confidentialInformation,
  incidentId,
  hasUpdateAccess,
}) => {
  const { authRole } = useAuth();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const addInlineStyles = (html) => {
    return html
      ?.replace(/<ul>/g, '<ul style="list-style-type: disc; margin-left: 20px; padding-left: 0;">')
      ?.replace(
        /<ol>/g,
        '<ol style="list-style-type: decimal; margin-left: 20px; padding-left: 0;">',
      )
      ?.replace(/<li>/g, '<li style="margin-bottom: 8px;">');
  };

  const styledDescription = addInlineStyles(description);
  const styledConfidentialInformation = addInlineStyles(confidentialInformation);

  return (
    <BaseCard className="pt-4 pb-6 xl:px-16 px-5 rounded-lg !mb-[0px]" elevation={1}>
      <div className="border-bottom mb-4 flex items-center pb-1">
        <h6 className="text-dark">Service Description</h6>
        {(authRole === UserType.CLIENT || authRole === UserType.CUSTOMER) && hasUpdateAccess && (
          <i
            className="fa-light fa-pencil text-gray-900 ml-3 cursor-pointer"
            onClick={() => setIsModalOpen(true)}
          ></i>
        )}
      </div>

      {description && (
        <div>
          <p className="text-base font-medium underline underline-offset-2">Work Description</p>
          <div
            className="min-h-72 text-[13px]"
            dangerouslySetInnerHTML={{ __html: styledDescription }}
          ></div>
        </div>
      )}
      {authRole === "CLIENT" && confidentialInformation && (
        <div>
          <p className="text-base font-medium underline underline-offset-2">
            Confidential Information
          </p>
          <div
            className="min-h-72 text-[13px]"
            dangerouslySetInnerHTML={{ __html: styledConfidentialInformation }}
          ></div>
        </div>
      )}
      {isModalOpen && (
        <EditServiceDescriptionModal
          open={isModalOpen}
          close={() => setIsModalOpen(false)}
          workOrderData={{
            serviceDescription: description,
            confidentialInformation: confidentialInformation,
            incidentId,
          }}
        />
      )}
    </BaseCard>
  );
};

export default ServiceDescription;
